import legalDocuments from "../constants/LEGAL_DOCUMENTS.json";

export type SupportedLegalLanguage = "en" | "es";
export type LegalDocumentKey = "termsOfService" | "privacyPolicy";

function normalizeLegalLanguage(lang: string | undefined): SupportedLegalLanguage {
  return lang?.toLowerCase().startsWith("es") ? "es" : "en";
}

export function getDocumentTitle(
  docKey: LegalDocumentKey,
  lang: string | undefined,
): string {
  const language = normalizeLegalLanguage(lang);
  const doc = legalDocuments.documents[docKey];
  return doc.title[language] ?? doc.title.en;
}

export function getDocumentVersion(
  docKey: LegalDocumentKey,
  lang: string | undefined,
): string {
  const language = normalizeLegalLanguage(lang);
  const doc = legalDocuments.documents[docKey];
  return doc.languages[language]?.version ?? doc.languages.en.version;
}

export function getDocumentContent(
  docKey: LegalDocumentKey,
  lang: string | undefined,
): string {
  const language = normalizeLegalLanguage(lang);
  const doc = legalDocuments.documents[docKey];
  return doc.languages[language]?.content ?? doc.languages.en.content;
}

// Combines both documents' versions into a single opaque string. The UI presents
// one checkbox covering both documents, so acceptance is tracked as a single
// composite value rather than per-document. Bumping either document's version
// changes this string, which re-gates all users on their next load.
export function getCurrentLegalVersion(lang: string | undefined): string {
  const tosVersion = getDocumentVersion("termsOfService", lang);
  const ppVersion = getDocumentVersion("privacyPolicy", lang);
  return `tos:${tosVersion}|pp:${ppVersion}`;
}
